// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toast
 * positioning and row layout only. Surface comes from ui-card. 
 */

.Toast_container__XSuf- {
  position: fixed;
  right: var(--gutter);
  bottom: var(--gutter);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: min(22rem, calc(100vw - 2 * var(--gutter)));
  pointer-events: none;
}

.Toast_container__XSuf- .Toast_toast__nd-uy {
  pointer-events: auto;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
  box-shadow: var(--shadow-md);
  animation: Toast_toast-in__13Psd var(--dur-med) var(--ease-standard) both;
  transition:
    opacity var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);
}

.Toast_container__XSuf- .Toast_leaving__0D29N {
  opacity: 0;
  transform: translateY(8px);
}

@keyframes Toast_toast-in__13Psd {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.Toast_container__XSuf- .Toast_chip__9FxJK {
  width: 32px;
  height: 32px;
  margin-top: 2px;
}

.Toast_body__PoUF1 {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 6px;
}

.Toast_title__vjRj\\+ {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  color: var(--text-primary);
}

.Toast_detail__y3Gbn {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
  overflow-wrap: anywhere;
}

.Toast_container__XSuf- .Toast_action__W5ETq {
  align-self: flex-start;
  margin-top: var(--space-1);
  margin-left: calc(-1 * var(--space-4));
}

.Toast_container__XSuf- .Toast_close__IVTok {
  flex: none;
  width: 36px;
  height: 36px;
  margin: 4px 0 0 0;
  color: var(--text-secondary);
}

.Toast_container__XSuf- .Toast_close__IVTok:hover {
  color: var(--text-primary);
}

@media (max-width: 600px) {
  .Toast_container__XSuf- {
    right: var(--gutter);
    left: var(--gutter);
    width: auto;
    align-items: stretch;
  }
}

@media (prefers-reduced-motion: reduce) {
  .Toast_container__XSuf- .Toast_toast__nd-uy {
    animation: none;
    transition: none;
  }

  .Toast_container__XSuf- .Toast_leaving__0D29N {
    opacity: 1;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Toast.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oEAAoE;EACpE,4BAA4B;EAC5B,yEAA4D;EAC5D;;kDAEgD;AAClD;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":["/* Toast\n * positioning and row layout only. Surface comes from ui-card. \n */\n\n.container {\n  position: fixed;\n  right: var(--gutter);\n  bottom: var(--gutter);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  width: min(22rem, calc(100vw - 2 * var(--gutter)));\n  pointer-events: none;\n}\n\n.container .toast {\n  pointer-events: auto;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);\n  box-shadow: var(--shadow-md);\n  animation: toast-in var(--dur-med) var(--ease-standard) both;\n  transition:\n    opacity var(--dur-fast) var(--ease-standard),\n    transform var(--dur-fast) var(--ease-standard);\n}\n\n.container .leaving {\n  opacity: 0;\n  transform: translateY(8px);\n}\n\n@keyframes toast-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.container .chip {\n  width: 32px;\n  height: 32px;\n  margin-top: 2px;\n}\n\n.body {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-top: 6px;\n}\n\n.title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.5;\n  color: var(--text-primary);\n}\n\n.detail {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  overflow-wrap: anywhere;\n}\n\n.container .action {\n  align-self: flex-start;\n  margin-top: var(--space-1);\n  margin-left: calc(-1 * var(--space-4));\n}\n\n.container .close {\n  flex: none;\n  width: 36px;\n  height: 36px;\n  margin: 4px 0 0 0;\n  color: var(--text-secondary);\n}\n\n.container .close:hover {\n  color: var(--text-primary);\n}\n\n@media (max-width: 600px) {\n  .container {\n    right: var(--gutter);\n    left: var(--gutter);\n    width: auto;\n    align-items: stretch;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .container .toast {\n    animation: none;\n    transition: none;\n  }\n\n  .container .leaving {\n    opacity: 1;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Toast_container__XSuf-`,
	"toast": `Toast_toast__nd-uy`,
	"toast-in": `Toast_toast-in__13Psd`,
	"leaving": `Toast_leaving__0D29N`,
	"chip": `Toast_chip__9FxJK`,
	"body": `Toast_body__PoUF1`,
	"title": `Toast_title__vjRj+`,
	"detail": `Toast_detail__y3Gbn`,
	"action": `Toast_action__W5ETq`,
	"close": `Toast_close__IVTok`
};
export default ___CSS_LOADER_EXPORT___;
